import React, { useState } from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import Link from 'next/link'
import { getKeyByValue } from '../tabMapping'
import { makeCommunityUrl } from 'Components/new/links/community-link'

interface SortItem {
  chi_name: string
  eng_name: string
}
interface IProps {
  current_sort: string
  sort_list: SortItem[]
  tab_name: string
  series_id: string
  series_name: string
  // currentPage: number
  // handleSortClick: (e: React.MouseEvent) => void
}

const Sort = ({
  current_sort,
  sort_list,
  tab_name,
  series_id,
  series_name,
}: // currentPage,

IProps) => {
  const [isShowList, setIsShowList] = useState(false)
  const handClick = () => {
    setIsShowList(false)
  }
  return (
    <div
      className="sort tw-text-12 md:tw-text-14 tw-mt-4"
      onMouseEnter={() => setIsShowList(true)}
      onMouseLeave={() => setIsShowList(false)}
    >
      <p className="tw-font-medium tw-flex tw-items-center">
        {current_sort}
        <i
          className={`DCD_Icon icon_PC-triangle-down`}
          style={{ display: 'inline-block' }}
        />
      </p>
      <div className="sort-list tw-flex tw-flex-col  tw-text-14 md:tw-text-16 ">
        {sort_list?.map((item) => {
          const { chi_name, eng_name } = item
          return (
            <Link
              key={eng_name}
              href={`/new_community`}
              as={makeCommunityUrl({
                id: series_id,
                tab: tab_name,
                sort: eng_name,
              })}
            >
              <a
                data-name={chi_name}
                onClick={() => {
                  handClick()
                  sendTeaCommEvent('clk_event', {
                    page_id: 'page_ugc_forum_home',
                    event_id:
                      tab_name === 'wenda'
                        ? 'select_module_button_qa_clk'
                        : 'select_module_button_dynamic_clk',
                    car_series_id: series_id,
                    car_series_name: series_name,
                    sub_tab:
                      tab_name === 'wenda' ? '问答' : getKeyByValue(tab_name),
                    module_id:
                      tab_name === 'wenda'
                        ? 'select_module_button_qa'
                        : 'select_module_button_dynamic',
                    obj_text: chi_name,
                  })
                }}
                className="list-item"
              >
                {chi_name}
              </a>
            </Link>
          )
        })}
      </div>

      <style jsx>
        {`
          .sort {
            cursor: pointer;
            height: 32px;
          }
          /*.sort:hover i {
            transform: rotate(180deg);
          }*/
          .sort-list {
            display: ${isShowList ? '' : 'none'};
            position: relative;
            left: -16px;
            z-index: 1;
            background-color: #ffffff;
            border-radius: 2px;
            box-shadow: rgb(0 0 0 / 20%) 0 2px 12px 0;
          }
          .list-item {
            height: 41px;
            padding: 10px 16px;
            color: black !important;
          }
          .list-item:hover {
            background-color: #fff9e6;
          }
        `}
      </style>
    </div>
  )
}

export default Sort
